import { useState } from "react";

// Generalizes CustodialView's ChecklistTab rendering — progress bar,
// checkable items, optional add/delete for editors. Takes plain items
// ({id, text, done, doneBy, doneAt}) and callbacks; has no idea whether
// these came from a janitorial ChecklistTemplate or an HVAC filter-change
// template, which is exactly the point (see spec's ChecklistTemplate
// entity — per-trade templates render through this same component).
export default function ChecklistRenderer({ items, onToggle, canEdit, onAdd, onDelete, fmtDate = (d) => String(d ?? "") }) {
  const [newItem, setNewItem] = useState("");
  const done = items.filter(i => i.done).length;
  const pct = items.length ? Math.round((done / items.length) * 100) : 0;

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
        <div style={{ fontSize:"13px", color:"#64748B", fontWeight:"600" }}>{done}/{items.length} complete</div>
        <div style={{ fontSize:"13px", fontWeight:"700", color: pct === 100 ? "#16A34A" : "#006B4F" }}>{pct}%</div>
      </div>
      <div style={{ height:"6px", background:"#E2E8F0", borderRadius:"3px", overflow:"hidden", marginBottom:"14px" }}>
        <div style={{ height:"100%", width:`${pct}%`, background: pct === 100 ? "#16A34A" : "#006B4F" }} />
      </div>
      <div style={{ background:"#fff", borderRadius:"12px", border:"1px solid #E2E8F0", overflow:"hidden" }}>
        {items.map((item, idx) => (
          <div key={item.id} style={{ display:"flex", alignItems:"center", gap:"10px", padding:"12px 16px", borderBottom: idx === items.length - 1 ? "none" : "1px solid #E2E8F0" }}>
            <div onClick={()=>onToggle(item)} style={{ width:"20px", height:"20px", borderRadius:"5px", border:`1.5px solid ${item.done ? "#16A34A" : "#E2E8F0"}`, background: item.done ? "#16A34A" : "#fff", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:"13px", cursor:"pointer" }}>
              {item.done && "✓"}
            </div>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:"14px", textDecoration: item.done ? "line-through" : "none", color: item.done ? "#94A3B8" : "#0F172A" }}>{item.text}</div>
              {item.done && item.doneBy && <div style={{ fontSize:"11px", color:"#94A3B8" }}>Marked by {item.doneBy} · {fmtDate(item.doneAt)}</div>}
            </div>
            {canEdit && onDelete && (
              <button onClick={()=>onDelete(item.id)} style={{ background:"transparent", border:"none", color:"#94A3B8", cursor:"pointer", fontSize:"16px" }}>×</button>
            )}
          </div>
        ))}
        {canEdit && onAdd && (
          <div style={{ display:"flex", gap:"8px", padding:"10px 16px" }}>
            <input style={{ flex:1, padding:"8px 10px", border:"1px solid #E2E8F0", borderRadius:"8px" }} placeholder="Add item…" value={newItem}
              onChange={e=>setNewItem(e.target.value)}
              onKeyDown={e=>{ if (e.key === "Enter" && newItem.trim()) { onAdd(newItem.trim()); setNewItem(""); } }} />
            <button onClick={()=>{ if (newItem.trim()) { onAdd(newItem.trim()); setNewItem(""); } }}
              style={{ padding:"8px 14px", borderRadius:"8px", border:"none", background:"#006B4F", color:"#fff", cursor:"pointer" }}>+ Add</button>
          </div>
        )}
        {items.length === 0 && (
          <div style={{ padding:"20px", textAlign:"center", color:"#94A3B8", fontSize:"13px" }}>No checklist items yet.</div>
        )}
      </div>
    </div>
  );
}
